<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Bricks for Bulls</h2>
                    <h3>Now’s the time to cement your legacy!</h3>
                    <div class="font-lg">
                        <p>
                            We are currently not accepting new brick orders at this time.
                            We appreciate your interest in supporting UB Athletics and the Bricks for Bulls campaign.
                            We invite you to visit us at <a href="http://www.bullsbwf.com/">www.BullsBWF.com</a> to learn about other ways to get involved to support our 300+ student athletes.
                            GO BULLS!
                        </p>
                        <!--<p class="color-red">-->
                            <!--<router-link to="/shop">-->
                                <!--<strong>Click here to order your brick today!</strong>-->
                            <!--</router-link>-->
                        <!--</p>-->
                    </div>
                    <p>
                        <!--<router-link to="/shop">-->
                            <img class="img-responsive" src="images/aboutbricks.png" alt="">
                        <!--</router-link>-->
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'about'
    }
</script>

<style lang="scss" scoped>
    p.color-red {
        a:hover, a:visited, a:link, a:active {
            text-decoration: none;
        }
        strong {
            color: #EA0029;
        }
    }
</style>



// WEBPACK FOOTER //
// About.vue?210387ec